import { connect } from 'react-redux';
import Component from './Component';
import {showLogin, showRegister, submitLogout} from "../Auth/Actions";

const mapStateToProps = (state) => (
  {
    isAuthorized: state.auth.isAuthorized,
    user: state.auth.user,
    onMainClick: state.main.onMainClick,
    cart: state.cart.list,
  }
);

const mapDispatchToProps = (dispatch) => (
  {
    showLogin: () => {
      dispatch(showLogin())
    },
    showRegister: () => {
      dispatch(showRegister())
    },
    submitLogout: () => {
      dispatch(submitLogout())
    }
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(Component);


// WEBPACK FOOTER //
// ./src/app/containers/Header/index.js